import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { authState } from "src/recoils";
import { GetCustomerStatusReason } from "src/services/customer/customer";

export const CUSTOMER_STATUS_REASON_QUERY_KEY = "customerStatusReason";

/** Latest admin reason for a customer's status change, or null when none was logged. */
export function useCustomerStatusReason(userCode?: string) {
  const { token = "" } = useRecoilValue(authState);
  return useQuery(
    [CUSTOMER_STATUS_REASON_QUERY_KEY, userCode],
    async () => {
      const response = await GetCustomerStatusReason({ token, user_code: userCode as string });
      return response.data ?? null;
    },
    { enabled: !!userCode }
  );
}
